import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { resetNodesState, updateAddNodes, updateLinks } from '../../../redux/features/nodes';
import { setGraphData, setFromDocuments } from '../../../redux/features/graph';

export const useGraphLoader = (documentData: any) => {
  const dispatch = useDispatch();
  
  useEffect(() => {
    if (!documentData) return;
    
    console.log("New document loading:", documentData.documentId, documentData.documentTitle);
    
    // 1. Reset all graph-related state
    dispatch(resetNodesState());
    dispatch({ type: 'graph/reset' });
    
    // 2. Load graph data from navigation state
    console.log("Loading graph from navigation state:", documentData);
    
    if (documentData.graphData) {
      dispatch(setGraphData(documentData.graphData));
    }
    
    // 3. Process nodes with proper coordinate transformation
    if (documentData.nodes && documentData.nodes.length > 0) {
      const currentWidth = window.visualViewport?.width || window.innerWidth;
      const currentHeight = window.visualViewport?.height || window.innerHeight;
      const savedWidth = documentData.plotWidth || currentWidth;
      const savedHeight = documentData.plotHeight || currentHeight;
      
      console.log("Coordinate transformation using dimensions:", {
        savedWidth, savedHeight, currentWidth, currentHeight
      });
      
      documentData.nodes.forEach((node:any) => {
        // Transform coordinates based on the ratio of current to saved dimensions
        const x = node.x * currentWidth;
        const y = node.y * currentHeight;
        
        dispatch(updateAddNodes({
          ...node,
          x,
          y
        }));
      });
      
      if (documentData.edges) {
        dispatch(updateLinks(documentData.edges));
      }
      
      console.log("Transformed", documentData.nodes.length, "nodes with", 
        documentData.edges ? documentData.edges.length : 0, "edges");
    }
    
    // 4. Set from documents flag at the end
    dispatch(setFromDocuments(false));
    
    console.log("Graph loaded successfully");
  }, [documentData, dispatch]);
};
